import {
  CircularProgress,
  Dialog,
  DialogContent,
  type DialogProps,
  Flex,
  Text,
} from '@shared/components';

export type GenerateSeatNumberLoadingModalProps = Pick<DialogProps, 'open'>;

export default function GenerateSeatNumberLoadingModal(
  props: Readonly<GenerateSeatNumberLoadingModalProps>,
) {
  const { open: isOpen } = props;
  return (
    <Dialog open={isOpen} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังสร้างเลขที่นั่งสอบ</Text>
          <Text color='secondary'>กรุณารอสักครู่ ระบบกำลังสร้างเลขที่นั่งสอบให้คุณ</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
